import { Location } from '@lib.core/entities/location/location';

export class LocationComposite {
  readonly id: string;
  geocodes: string[] = [];
  geoType = '';
  countryCode = '';

  constructor(id: string) {
    this.id = id;
  }

  setGeocodes(geocodes: string[]): this {
    this.geocodes = geocodes;
    return this;
  }

  setGeoType(geoType: string): this {
    this.geoType = geoType;
    return this;
  }

  setCountryCode(countryCode: string): this {
    this.countryCode = countryCode;
    return this;
  }

  static fromCensusLocationId(locationId: string, location?: Location): [LocationComposite | null, Error | null] {
    const mainLoc = new LocationComposite(locationId);
    let [cc, geoType, geocode] = locationId.split('-');
    cc = cc.trim().length === 0 ?  location?.countryCode ?? '' : cc;
    geoType = !geoType || geoType.trim().length === 0 ?  location?.geoType ?? '' : geoType;
    geocode = !geocode || geocode.trim().length === 0 ?  location?.geoCode ?? '' : geocode;

    mainLoc.setCountryCode(cc).setGeoType(geoType).setGeocodes([geocode]);
    const err = mainLoc.validate();
    if (err !== null) {
      return [null, err];
    }
    return [mainLoc, null];
  }

  validate(): Error | null {
    if (this.countryCode !== 'ca' && this.countryCode !== 'us') {
      return new Error(`Invalid country code: ${this.countryCode}`);
    }
    if (this.geoType.length < 1) {
      return new Error(`Invalid geo type ${this.geoType}`);
    }
    if (this.geocodes.length < 1) {
      return new Error(`Invalid geocode list: ${this.geocodes}`);
    }
    return null;
  }
}
